import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OtherFinancialLiabilitiesRommsProps {
  onBack?: () => void;
}

export default function OtherFinancialLiabilitiesRomms({
  onBack,
}: OtherFinancialLiabilitiesRommsProps) {
  return (
    <PayrollRomms
      onBack={onBack || (() => {})}
      onComplete={() => {}}
      workspace="Other Financial Liabilities"
    />
  );
}
